import React, { Component } from 'react';
import { connect } from 'react-redux';

import Section from '../../UI/Section';
import {PieChart,Pie,Cell,Tooltip} from 'recharts';
import * as userActions from '../../../_actions/userActions';
import getTopProfileVisitors from '../../../_selectors/userSelectors/getTopProfileVisitors';

class PieGraph extends Component {
  componentDidMount() {
    const {getVisitors} = this.props;
    this.unsubscribe = getVisitors();
  }
  componentWillUnmount() {
    try {
      this.unsubscribe();
    } catch (error) {
      //nothing
    }
  }
  render() {
    const {results} = this.props;
    if(!results){
return null;
    }
    const data = [{name:'Male',value:results.male||0},{name:'Female',value:results.female||0}];
    const data1 =  [{name:'Likes',value:50},{name:'Interests',value:30},{name:'Saves',value:30},{name:'Shortlists',value:30},{name:'Interests',value:30}];
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042','#8884d8'];
    return (
      <Section white>
      <div className="row">
        <div className="col-md-6">
          <PieChart width={730} height={250}>
              <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius="40" outerRadius={80} fill="#8884d8" label>
              {
                  data.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]}/>)
              }
              </Pie>
              <Tooltip/>
          </PieChart>
        </div>
        <div className="col-md-6">
          <PieChart width={730} height={250}>
              <Pie data={data1} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius="40" outerRadius={80} fill="#8884d8" label>
              {
                  data1.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]}/>)
              }
              </Pie>
              <Tooltip/>
          </PieChart>
        </div>
      </div>
          
      </Section>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  results: getTopProfileVisitors(state)
});

const mapDispatchToProps = dispatch => ({
  getVisitors: () => dispatch(userActions.getTopProfileVisitors())
});

export default connect(mapStateToProps, mapDispatchToProps)(PieGraph);


// WEBPACK FOOTER //
// ./src/_components/Home/PieGraph/index.js